import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, MessageCircle, Megaphone } from 'lucide-react';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/ara?q=${encodeURIComponent(searchQuery.trim())}`);
      setIsSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <>
      {/* Mobile Bottom Navigation */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-[100]">
        <div className="flex items-center justify-around px-4 py-3">
          {/* WhatsApp */}
          <a
            href="https://wa.me/905551234567"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-1 text-gray-600 hover:text-green-500 transition"
          >
            <MessageCircle size={24} />
            <span className="text-xs font-medium">Whatsapp</span>
          </a>

          {/* Search - Large Orange Button */}
          <button
            onClick={() => setIsSearchOpen(!isSearchOpen)}
            aria-label="Ara"
            className="w-16 h-16 -mt-8 bg-orange-500 rounded-full flex items-center justify-center shadow-lg hover:bg-orange-600 transition transform hover:scale-105"
          >
            <Search size={28} aria-hidden="true" className="text-white" />
          </button>

          {/* Announcements */}
          <Link
            to="/duyurular"
            className="flex flex-col items-center gap-1 text-gray-600 hover:text-[#2171b5] transition"
          >
            <Megaphone size={24} />
            <span className="text-xs font-medium">Duyurular</span>
          </Link>
        </div>
      </div>

      {/* Search Modal */}
      {isSearchOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[60] flex items-start justify-center pt-20 lg:hidden"
          onClick={() => setIsSearchOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-11/12 max-w-md p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-bold mb-4">Ara</h3>
            <form onSubmit={handleSearchSubmit}>
              <input
                type="text"
                placeholder="Arama yapın..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2171b5]"
                autoFocus
              />
              <div className="mt-4 flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setIsSearchOpen(false)}
                  className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition"
                >
                  Kapat
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#2171b5] text-white rounded-lg hover:bg-[#1e5a8e] transition font-bold"
                >
                  Ara
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileBottomNav;

